import { FC, InputHTMLAttributes, useRef } from 'react'
import { RadioContainer } from './styles'
import { useErrors } from 'src/context/errors';

interface StandardRadioProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  variant?: 'default' | 'outlined',
  isIncorrect?: boolean;
  errorCode?: string;
}

const StandardRadio: FC<StandardRadioProps> = ({ checked, label, variant, isIncorrect, errorCode = '', ...rest }) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const { hasError } = useErrors()

  isIncorrect = hasError(errorCode) || isIncorrect

  const onRadioClick = () => {
    if(!!inputRef && !!inputRef.current) inputRef.current.click()
  }
  
  return (
    <RadioContainer isIncorrect={isIncorrect === true} checked={!!checked} onClick={() => onRadioClick()} variant={variant ?? 'default'}>
      <div data-error-code={errorCode} className='ball'/>
      <input ref={inputRef} {...rest} checked={checked} type="radio"/>
      <span>{label}</span>
    </RadioContainer>
  )
}

export default StandardRadio